import state from "./state";
import * as mutations from "./mutation"

const namespaced = true;

export default{
  namespaced,
  state,
  mutations
};